import { useMutation } from '@tanstack/react-query';

import { agent } from 'api/agent';

const logOutMutation = () => useMutation({
  mutationKey: ['logOut'],
  mutationFn: () => agent.getClient(false).post('/auth/logout'),
  onSuccess: () => { },
});

export default logOutMutation;
